import {css} from '../theme/css'
import {breakpoints} from '../theme/theme'

export const classes = {
  backdrop: css`
    && {
      position: fixed;
      height: auto;
      width: auto;
      inset: 0;
    }
  `,
  modal: css`
    text-align: start;
    position: relative;

    ${breakpoints.down('sm')} {
      max-block-size: 100%;
    }
  `,
  modalBody: css`
    overflow-x: hidden;
  `,
  // перебиваю инлайновые маржины GWC 🥰 внутри круглой кнопки с крестиком, которые растягивают ее в овал
  modalHeader: css`
    & > button > span > svg {
      margin-inline: 0 !important;
    }
  `,
}
